const localTomcatConfig = {
  statusBar: {
    visibility: true,
    messgae: "UnderDevelopmentStatusBand",
    color: "red"
  },
  backend: {
    url: "https://localhost:8080/"
  },
  apps: {
    url: "https://localhost:9000/"
  },
  annualReport: {
    url: "https://localhost:9000/annualreport"
  },
  annualReportWithHash: {
    url: "https://localhost:9000/#/annualreport"
  },
  corporatePage: {
    url: "http://localhost:3000/"
  },

  SRU: {
    url: "https://localhost:9000/income-declaration-2"
  },
  NE: {
    url: "https://localhost:9000/income-declaration-1"
  },
  forAccountingCompanies: {
    url: "https://localhost:9000/for-accounting-companies"
  },
  microsoftBusinessCentral: {
    url: "https://localhost:9000/microsoft-business-central-development"
  },
  ContactUs: {
    uploadFileSizeLimit: 2
  },
  Skatteverket: {
    environment: "localEnvironment"
  }
};

export default localTomcatConfig;
